import { IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";

import getIcons from "../../SolarGikLib/icons/Icons";
import { GeneralIcons, IconCategory } from "../../SolarGikLib/icons/IconsModels";
import { iconButtonStyle } from "../../SolarGikLib/styles/ButtonsStyle";

const InteractiveSolargikLogo = () => {
  const navigate = useNavigate();
  const SolarGikLogoIcon = getIcons(GeneralIcons.HeaderSolargikLogo, IconCategory.General);
  return (
    <IconButton
      onClick={() => {
        navigate(`/`);
      }}
      style={iconButtonStyle}
    >
      <SolarGikLogoIcon />
    </IconButton>
  );
};

export default InteractiveSolargikLogo;
